<template>
    <v-container v-resize="onResize">
        <statistical-header :title="title"></statistical-header>
        <loader v-if="loading" />
        <template v-if="!loading">
            <v-layout row wrap align-center justify-space-between>
                <v-btn-toggle v-model="chartType" class="transparent handbook_toggleButton" :mandatory="true">
                    <v-tooltip top :disabled="this.$vuetify.breakpoint.name !== 'md'">
                        <template v-slot:activator="{ on }">
                            <v-btn v-on="on" class="handbook_button" :value="'byPartyLengthOfService'">
                                <span class="long-button-text chamberButton">Party by Length of Service</span>
                            </v-btn>
                        </template>
                        <span>Party by Length of Service</span>
                    </v-tooltip>
                    <v-tooltip top :disabled="this.$vuetify.breakpoint.name !== 'md'">
                        <template v-slot:activator="{ on }">
                            <v-btn v-on="on" class="handbook_button" :value="'numberByParty'">
                                <span class="long-button-text chamberButton">Party by Number</span>
                            </v-btn>
                        </template>
                        <span>Party by Number</span>
                    </v-tooltip>
                </v-btn-toggle>
            </v-layout>
            <br />

            <chart v-show="chartType === 'byPartyLengthOfService'" :chartData="byPartyLengthOfServiceChartData"/>   
            <chart v-show="chartType === 'numberByParty'" :chartData="numberByPartyChartData"/>   

             <br/>
            <div class="stats-table">
                <v-data-table
                    :headers="headers" 
                    :items="items"
                    :hide-actions="true"
                    :loading="loading"
                    :hide-headers="isMobile"
                    :class="{ mobileDataTable: isMobile, 'elevation-1': true }"
                    :custom-sort="customSort"
                    :disable-initial-sort="true">
                    <template v-slot:items="props">
                        <template v-if="isMobile">
                            <tr>
                                <td>
                                    <div class="flex-content">
                                        <div class="flex-item">
                                            <h3 class="pb-xs-1"><router-link :to="{ name: $store.state.ROUTE_PARLIAMENTARIAN, params: { PHID: props.item.Phid }}">{{ props.item.DisplayName }}</router-link></h3>
                                        </div>
                                        <div class="flex-item flex-item-col flex-item-col-30">
                                            <div class="flex-item">
                                                <Portrait v-bind:PHID="props.item.Phid" :fixedWidth="80"></Portrait>
                                            </div>
                                        </div>
                                        <div class="flex-item flex-item-col flex-item-col-70">
                                            <div class="flex-item" data-label="Party">
                                                <div v-for="party in props.item.PartyList" :key="party.$key" ><a @click="handlePartyClick(party.Name)">{{ party.Name }}</a></div>
                                            </div>
                                            <div class="flex-item" data-label="Period of service">
                                                <div v-for="service in props.item.PeriodOfService" :key="service.$key">
                                                    {{ service.DateStart | stringDateFormat }}–{{ service.DateEnd | stringDateFormat }}
                                                </div>
                                            </div>
                                            <div class="flex-item" data-label="Length of service">
                                                {{ props.item.Years }} years, {{ props.item.Months }} months, {{ props.item.Days }} days
                                            </div>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </template>
                        <template v-if="!isMobile">
                            <td class="text-xs-left">
                                <Portrait v-bind:fixedWidth="80" v-bind:PHID="props.item.Phid"></Portrait>
                            </td>
                            <td class="text-xs-left"><router-link :to="{ name: $store.state.ROUTE_PARLIAMENTARIAN, params: { PHID: props.item.Phid }}">{{ props.item.DisplayName }}</router-link></td>
                            <td class="text-xs-left">
                                <span v-for="(party, index) in props.item.PartyList" :key="party.$key" >
                                    <span v-if="index > 0">, </span><a @click="handlePartyClick(party.Name)">{{ party.Name }}</a>
                                </span>
                            </td>
                            <td class="text-xs-left">
                                <div v-for="service in props.item.PeriodOfService" :key="service.$key">
                                    {{ service.DateStart | stringDateFormat }}–{{ service.DateEnd | stringDateFormat }}
                                </div>
                            </td>
                            <td class="text-xs-left">
                                {{ props.item.Years }}
                            </td>
                            <td class="text-xs-left">
                                {{ props.item.Months }}
                            </td>
                            <td class="text-xs-left">
                                {{ props.item.Days }}
                            </td>
                        </template>
                    </template>
                </v-data-table>
            </div>
            <br/>
            <v-layout row wrap>
                <v-flex xs12>
                    <v-btn class="csvButton" @click="exportCsv" v-on:keyup.enter="exportCsv" color="primary">
                        <v-icon aria-hidden="true" :class="csvDownloadClass">{{csvDownloadIcon}}</v-icon>
                        <span>&nbsp;Download as CSV</span>
                    </v-btn>
                </v-flex>
            </v-layout>            
        </template>
    </v-container>
</template>
<script>
import Loader from '@/components/Loader.vue';
import StatisticalHeader from './StatisticalHeader.vue';
import Chart from './Chart.vue';
import axios from 'axios';
window.Handbook = window.Handbook || {}
const apiUri = window.Handbook.ApiUri || "https://localhandbookapi.aph.gov.au/";
axios.defaults.baseURL = apiUri;
import Portrait from '@/components/Portrait.vue'
import orderBy from 'lodash.orderby';

export default {
    created() {
        this.initialiseItems();
    },
    components: {
        Loader,
        StatisticalHeader,
        Chart,
        Portrait,
    },
     mounted() {
        this.onResize();
    },
    methods: {
        onResize() {
            if (window.innerWidth < 769){
                this.isMobile = true;
            }
            else{
                this.isMobile = false;
            }
        },
        changeSort(column) {
            if (this.PAGINATION.sortBy === column) {
                this.PAGINATION.descending = !this.PAGINATION.descending
            } 
            else {
                this.PAGINATION.sortBy = column
                this.PAGINATION.descending = false
            }
        },
        initialiseItems() {
            this.loading = true;
            const url = `StatisticalInformation/LeadersOfTheOpposition`;
            axios.get(`api/${url}`)
                .then(response => {
                    this.items = response.data;
                    this.items = this.items.map(c => ({ ...c, PartyList: [...new Map(c.Party.map(item => [item['Id'], item])).values()] }));
                    this.loading = false;
                });
        },
        filterMpOrSenator() {
            this.initialiseItems();
        },
        handlePartyClick(partyId) {
            const query = {
                "logicalOperator":"all",
                "children":[]};
            if (partyId) {
                var partyVal = "[{\"field\":\"RefList1\",\"value\":[],\"simpleValue\":[],\"textValue\":\"" + partyId + "\",\"dateValue\":null,\"fieldType\":null}]";
                query.children.push({"type":"query-builder-rule","query":{"rule":"parties.represented.new","selectedOperator":"of","selectedOperand":"Parties represented","value":partyVal}});
            }
            localStorage.query = JSON.stringify(query);    
            this.$router.push('/AdvancedSearch');
        },
        customSort(items, index, isDesc) {
            items.sort((a, b) => {
                if (index === "PeriodOfService") {
                    // for items, get party
                    // a is less than b is -1
                    // a is greater than b is 1
                    const aService = a[index][0].DateStart;
                    const bService = b[index][0].DateStart;
                    if (!isDesc) {
                        return aService < bService ? -1 : 1;
                    } else {
                        return bService < aService ? -1 : 1;
                    }
                } else if (index === 'Party') {
                    const aService = a[index][0].Name;
                    const bService = b[index][0].Name;
                    if (!isDesc) {
                        return aService < bService ? -1 : 1;
                    } else {
                        return bService < aService ? -1 : 1;
                    }
                } else {
                    if (!isDesc) {
                        return a[index] < b[index] ? -1 : 1;
                    } else {
                        return b[index] < a[index] ? -1 : 1;
                    }
                }
            });
            return items;
        },
        exportCsv: function () {
            this.csvDownloading = true;
            const records = this.items.map(i => 
                ({ 
                    Phid: i.Phid,
                    Name: i.DisplayName, 
                    Party: i.Party.map(p => p.Name).join(', '),
                    'Period of service': i.PeriodOfService.map(p => `${new Date(p.DateStart).toLocaleDateString()}–${(p.DateEnd && new Date(p.DateEnd).toLocaleDateString()) || 'present'}`).join('\n'),
                    Years: i.Years,
                    Months: i.Months,
                    Days: i.Days
                }));
            let headers = this.headers.map(h => h.text);
            const filename = 'Leaders of the Opposition';
            const comment = `Data current as of ${(new Date()).toLocaleDateString()}`;
            this.$store.dispatch('GETCSV', { DATA: records, HEADERS: headers, FILENAME: filename, COMMENT: comment })
                .catch(this.showError)
                .finally(() => this.csvDownloading = false);
        }
    },
    computed: {
            csvDownloadIcon(){
                return this.csvDownloading ? 'cached' : 'text_snippet';
            },
            csvDownloadClass(){
                let csvClass = 'mr-1';
                if (this.csvDownloading){
                    csvClass = csvClass + ' loading'
                }
                return csvClass;
            },
            uniqueParties() {
                return [...new Set(this.items.flatMap(i => i.Party).map(i => i.Name))];
            },
            formattedItems() {
                return [...this.items].map(item => {
                    // need to assign 
                    const newData = [];
                    item.PeriodOfService.forEach(d => {
                        // find party
                        if (item.Party.length === 1) {
                            // d.PartyColour = item.Party[0].Colour;
                            // d.PartyName = item.Party[0].Name
                            newData.push({
                                ...d,
                                PartyColour: item.Party[0].Colour,
                                PartyName: item.Party[0].Name,
                                TotalDays: Math.floor(((d.DateEnd ? new Date(d.DateEnd) : new Date()) - new Date(d.DateStart)) / 86400000)
                            });
                        } else {
                            // need to break record up into segments
                            // for each party
                            // find matching parties
                            item.Party.filter(p => (new Date(p.DateStart) < new Date(d.DateEnd) && new Date(p.DateEnd) > new Date(d.DateStart))).forEach(p => {
                                // find fully matching segment
                                if (new Date(d.DateStart) >= new Date(p.DateStart).valueOf() && new Date(d.DateEnd) <= new Date(p.DateEnd)) {
                                    // d.PartyColour = p.Colour;
                                    // d.PartyName = p.Name
                                    newData.push({
                                        ...d,
                                        PartyColour: p.Colour,
                                        PartyName: p.Name,
                                        TotalDays: Math.floor(((d.DateEnd ? new Date(d.DateEnd) : new Date()) - new Date(d.DateStart)) / 86400000)
                                    });
                                } else {
                                    const newSegment = {
                                        ...d,
                                        DateStart: new Date(p.DateStart) > new Date(d.DateStart) ? p.DateStart : d.DateStart,
                                        DateEnd: p.DateEnd && new Date(p.DateEnd) < new Date(d.DateEnd) ? p.DateEnd : d.DateEnd, 
                                        PartyColour: p.Colour,
                                        PartyName: p.Name,
                                    };
                                    newSegment.TotalDays = Math.floor(((newSegment.DateEnd ? new Date(newSegment.DateEnd) : new Date()) - new Date(newSegment.DateStart)) / 86400000)
                                    newData.push(newSegment);
                                }
                            });
                        }
                    });

                    return {
                        ...item,
                        PeriodOfService: newData,
                    }
                });
            },            
            byPartyLengthOfServiceChartData() {
                const parties = orderBy(this.uniqueParties, 
                        [p => this.formattedItems.flatMap(i => i.PeriodOfService).filter(i => i.PartyName === p).reduce((a, b) => a + b.TotalDays, 0)],
                        ['desc']
                    );

                const series = [...this
                    .formattedItems]
                    .reverse()
                    .map(i => ({
                    name: i.DisplayName,                    
                    data: parties
                        .map(p => i.PeriodOfService.findIndex(pa => pa.PartyName === p) !== -1 ? { 
                            y: Math.round(i.PeriodOfService.filter(pa => pa.PartyName === p).reduce((a, b) => a + b.TotalDays / 365.2425, 0) * 10) / 10, 
                            color: i.PeriodOfService.find(pa => pa.PartyName === p).PartyColour 
                        } : 0)
                    }));
                return {
                chart: {
                    type: 'bar'
                },
                title: {
                    text: 'Leaders of the Opposition by party and length of service'
                },
                xAxis: {
                    categories: parties
                },
                yAxis: {
                    title: {
                        text: 'Years of service'
                    }
                },
                exporting: {
                    filename: 'Leaders of the Opposition by party and length of service'
                },
                tooltip: {
                    valueSuffix: ' years'
                },
                legend: {
                    enabled: false
                },
                series
                }
            },
            numberByPartyChartData() {
                const parties = orderBy(this.uniqueParties, 
                [p => this.formattedItems.flatMap(i => this._.uniqBy(i.PeriodOfService, 'PartyName')).filter(i => i.PartyName === p).length,
                p => p],
                ['desc', 'asc'],
                );
                return {
                    chart: {
                        type: 'bar'
                    },
                    title: {
                        text: 'Number of Leaders of the Opposition by party'
                    },
                    xAxis: {
                        categories: parties
                    },
                    yAxis: {
                        title: {
                            text: ''
                        }
                    },
                    exporting: {
                        filename: 'Leaders of the Opposition by party'
                    },
                    legend: {
                        enabled: false
                    },
                    series: [{
                        name: 'Leaders of the Opposition',
                        data: orderBy(parties
                        .map(p => ({ 
                            y: this.formattedItems.flatMap(i => this._.uniqBy(i.PeriodOfService, 'PartyName')).filter(i => i.PartyName === p).length,
                            color: this.formattedItems.flatMap(i => i.PeriodOfService).find(i => i.PartyName === p).PartyColour })),
                        [i => i],
                        ['desc']
                        )
                    }] 
                }
            }
    },    
    watch: {
        selectedMpOrSenator: function () {
            this.initialiseItems();
        }
    },
    data() {
        return {
        isMobile: false,
        title: 'Leaders of the Opposition',
        chartType: 'byPartyLengthOfService',
        headers: [
             {
                text: 'Photo',
                value: 'DisplayName',
                sortable: false,
                width: '100px'
            },
            {
                text: 'Name',
                value: 'DisplayName' 
            },
            {
                text: 'Party',
                value: 'Party'
            },
            {
                text: 'Period of service',
                value: 'PeriodOfService'
            },
            {
                text: 'Years',
                value: 'Years'
            },
            {
                text: 'Months',
                value: 'Months'
            },
            {
                text: 'Days',
                value: 'Days'
            }
        ],
        PAGINATION: {
            rowsPerPage: -1,
            sortBy: '',
            descending: false
        },
        items: [],
        search: '',
        loading: true,
        csvDownloading: false,
        selectedMpOrSenator: ['senator', 'mp'],
        memberOrSenator: 'member',
        rowsPerPageItems: [ 10, 25, {
            "text": "$vuetify.dataIterator.rowsPerPageAll",
            "value": -1
            }]
        }
    }
}
</script>
<style scoped>
    a {
        text-decoration: none;
    }
</style>
<style lang="stylus" scoped>
     @media screen and (max-width: 1420px) {
        .stats-table >>> table.v-table thead td:not(:nth-child(1)), 
        .stats-table >>> table.v-table tbody td:not(:nth-child(1)), 
        .stats-table >>> table.v-table thead th:not(:nth-child(1)), 
        .stats-table >>> table.v-table tbody th:not(:nth-child(1)), 
        .stats-table >>> table.v-table thead td:first-child, 
        .stats-table >>> table.v-table tbody td:first-child, 
        .stats-table >>> table.v-table thead th:first-child, 
        .stats-table >>> table.v-table tbody th:first-child,
        .stats-table >>> table.v-table thead th:first-child {
            padding: 0 14px !important;
        }

        .stats-table >>> th {
            white-space: break-spaces;
        }
    }

</style>